import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-eula',
  templateUrl: './eula.component.html',
  styleUrls: ['./eula.component.css']
})
export class EulaComponent implements OnInit {
  hide = true;

  constructor() { }

  ngOnInit(): void {

    setTimeout(()=> {
      this.hide = false;
    }, 500)
  }

}
